import { openChatwoot } from '../Chatwoot'

const OPEN_EVENT = 'chatwoot-customer:open'

// Asks the mounted customer chat bubble to open. A surface without one (e.g.
// the onboarding handover, or a demo company) gets the stock widget instead, so
// a contact button never silently does nothing.
export function openChatwootCustomerChat() {
  const unanswered = window.dispatchEvent(
    new Event(OPEN_EVENT, { cancelable: true })
  )
  if (unanswered) {
    openChatwoot()
  }
}

export function onOpenChatwootCustomerChat(open: () => void) {
  function answer(event: Event) {
    // Tells openChatwootCustomerChat a bubble handled it, so no fallback.
    event.preventDefault()
    open()
  }
  window.addEventListener(OPEN_EVENT, answer)
  return () => window.removeEventListener(OPEN_EVENT, answer)
}
